module.exports = __webpack_public_path__ + "img/1.4ab19ce3.png";